import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {signupFormView_template} from "../components/templates/signupFormView_template";

declare var ko: any;
declare var page: any;

export class signup_form_view extends vnModule_knockoutJS {

    protected signupFormView: signupFormView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.signupFormView = new signupFormView_template("signupFormView", this.viewModel, this);
        return [this.signupFormView.build()];
    }

    protected getModuleName(): string {
        return "signup_form_view";
    }

    fillPage() {
        this.getSignupFormDataForView()
    }

    private getSignupFormDataForView() {

        this.loadingIn(this.signupFormView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/signupForm/get/view/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetSignupFormDataForView;
        this.XHRHdl.execute();
    }

    private onGetSignupFormDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let signupForm = responseParsed.data
                obj.signupFormView.setSignupFormData(signupForm);
            });

            obj.loadingOut(obj.signupFormView.builtTemplate);
        }
    }

    protected onClickEditSignupForm(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/signup-forms/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/signup-forms/")
    }
}


// WEBPACK FOOTER //
// ./js/modules/signup_form_view.ts